"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartCheckoutGraphRequestToCheggResponse = exports.addressValidationGraphRequestToCheggResponse = exports.graphRequestToCheggResponse = exports.sendBFFCall = exports.areMessagesFatal = exports.postRequestToCheggResponse = exports.addErrorType = exports.determineFailureType = exports.addErrorPrefix = exports.convertBFFErrors = exports.addCartCheckoutErrorData = void 0;
var tslib_1 = require("tslib");
var GraphApi_1 = tslib_1.__importDefault(require("../../API/GraphApi"));
var constants_1 = require("../authorize/constants");
var constants_2 = require("../methodOfPaymentAPI/bff/constants");
var interfaces_1 = require("./interfaces");
var transformCartCheckoutSuccessData_1 = require("./transforms/transformCartCheckoutSuccessData");
var index_1 = require("../addressValidationApi/index");
var hardFailures = [
    2,
    3,
    4,
    5,
    8,
    9,
    10,
    12,
    14,
    607,
    608,
    609,
    610,
    901,
];
function addCartCheckoutErrorData(errors) {
    errors = determineFailureType(errors);
    errors = addErrorPrefix(errors, 'ORD');
    errors = addErrorType(errors, interfaces_1.ErrorType.SERVER);
    return errors;
}
exports.addCartCheckoutErrorData = addCartCheckoutErrorData;
function convertBFFErrors(errors) {
    var baseErrors = errors.map(function (error) { return ({
        message: error.message,
        code: error.code,
        type: interfaces_1.ErrorType.SERVER,
    }); });
    baseErrors = determineFailureType(baseErrors);
    return baseErrors;
}
exports.convertBFFErrors = convertBFFErrors;
/**
 * Adds a given prefix to the error code
 * @param error - error object
 * @param errorPrefix - error message prefix
 */
function addErrorPrefix(errors, errorPrefix) {
    var mappedErrors = errors.map(function (error) {
        var newCode = error.code ? "".concat(errorPrefix, "-").concat(error.code) : undefined;
        return tslib_1.__assign(tslib_1.__assign({}, error), { code: newCode });
    });
    return mappedErrors;
}
exports.addErrorPrefix = addErrorPrefix;
/**
 *
 * @param errors - Base Error array
 * @returns - CartCheckoutError Array
 */
function determineFailureType(errors) {
    return errors.map(function (error) {
        var re = /ORD-(?<code>\d+)/i;
        var numericErrorCode = 0;
        //@ts-ignore
        if (typeof error.code === 'number') {
            numericErrorCode = error.code;
        }
        else if (typeof error.code === 'string' && error.code.match(re)) {
            numericErrorCode = Number(error.code.match(re).groups.code);
        }
        return tslib_1.__assign(tslib_1.__assign({}, error), { isFatalError: hardFailures.includes(numericErrorCode) });
    });
}
exports.determineFailureType = determineFailureType;
function addErrorType(errors, errorTypeAdded) {
    var mappedErrors = errors.map(function (error) {
        return tslib_1.__assign(tslib_1.__assign({}, error), { type: errorTypeAdded });
    });
    return mappedErrors;
}
exports.addErrorType = addErrorType;
function postRequestToCheggResponse(responseParams) {
    return responseParams
        .then(function (result) {
        var responseData = result.data;
        var errors = responseData.errors
            ? addCartCheckoutErrorData(responseData.errors)
            : null; // we shouldn't try to map errors if there are none
        return {
            errors: errors,
            data: responseData,
        };
    })
        .catch(function (error) { return JSON.parse(error.message); });
}
exports.postRequestToCheggResponse = postRequestToCheggResponse;
var areMessagesFatal = function (messages) {
    return messages.some(function (message) { return ![interfaces_1.Level.INFO, interfaces_1.Level.WARN].includes(message.level); });
};
exports.areMessagesFatal = areMessagesFatal;
function sendBFFCall(operationName, data, dataTransformer, mappedOperationNames) {
    var response = GraphApi_1.default.doFetchPersistedQuery(operationName, data).then(function (result) {
        return result;
    });
    return dataTransformer
        ? dataTransformer(graphRequestToCheggResponse(response, operationName, mappedOperationNames))
        : graphRequestToCheggResponse(response, operationName, mappedOperationNames);
}
exports.sendBFFCall = sendBFFCall;
function graphRequestToCheggResponse(responseParams, operationName, mappedOperationNames) {
    return responseParams.then(function (_a) {
        var e_1, _b, e_2, _c;
        var _d, _e;
        var _f = _a.data, graphQLData = _f.data, errors = _f.errors;
        var success = true;
        var extractedData = null;
        if (graphQLData) {
            if (graphQLData[operationName]) {
                extractedData = graphQLData[operationName];
            }
            else if (mappedOperationNames) {
                try {
                    for (var mappedOperationNames_1 = tslib_1.__values(mappedOperationNames), mappedOperationNames_1_1 = mappedOperationNames_1.next(); !mappedOperationNames_1_1.done; mappedOperationNames_1_1 = mappedOperationNames_1.next()) {
                        var mappedOperationName = mappedOperationNames_1_1.value;
                        if (graphQLData[mappedOperationName]) {
                            extractedData = graphQLData[mappedOperationName];
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (mappedOperationNames_1_1 && !mappedOperationNames_1_1.done && (_b = mappedOperationNames_1.return)) _b.call(mappedOperationNames_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        if (errors) {
            var resolvedError = null;
            try {
                for (var _g = tslib_1.__values(errors), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var error = _h.value;
                    var errorCode = (_e = (_d = error.extensions) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : '';
                    if (errorCode in interfaces_1.GRAPHQL_AUTHENTICATION_ERRORS) {
                        resolvedError = constants_1.AuthorizeErrors.AUTHORIZE_FAILURE;
                        resolvedError.originalError = error;
                        break;
                    }
                    else if (errorCode in interfaces_1.GRAPHQL_BAD_REQUEST_ERRORS) {
                        resolvedError = constants_1.AuthorizeErrors.BAD_REQUEST;
                        resolvedError.originalError = error;
                        break;
                    }
                    else if (errorCode in constants_2.GRAPHQL_PAYMENT_ERRORS) {
                        /*
                        There is some inconsistency in the response from cartCheckout and payment responses.
                        Payment service may return an actionable error that we need to return to the client, so
                        we cannot convert the error to a CSDK error.
                      */
                        resolvedError = null;
                        break;
                    }
                    else {
                        resolvedError = constants_1.AuthorizeErrors.UNKNOWN_FAILURE;
                        resolvedError.originalError = error;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                }
                finally { if (e_2) throw e_2.error; }
            }
            if (resolvedError) {
                errors = [resolvedError];
                success = false;
            }
        }
        var response = {
            data: extractedData,
            errors: errors,
            success: success,
        };
        if (!success) {
            throw new Error(JSON.stringify(response));
        }
        return response;
    });
}
exports.graphRequestToCheggResponse = graphRequestToCheggResponse;
function addressValidationGraphRequestToCheggResponse(responseParams) {
    return responseParams
        .then(function (result) {
        return (0, index_1.addressValidationDataTransformer)(result);
    })
        .catch(function (error) {
        return JSON.parse(error.message);
    });
}
exports.addressValidationGraphRequestToCheggResponse = addressValidationGraphRequestToCheggResponse;
function cartCheckoutGraphRequestToCheggResponse(responseParams) {
    return responseParams
        .then(function (_a) {
        var _b;
        var data = _a.data, errors = _a.errors, success = _a.success;
        //If we have already encountered a fatal error, don't even bother checking messages
        if (!success) {
            return {
                success: success,
                errors: errors,
                data: null,
            };
        }
        if (((_b = data === null || data === void 0 ? void 0 : data.messages) === null || _b === void 0 ? void 0 : _b.length) > 0 && (0, exports.areMessagesFatal)(data.messages)) {
            return {
                success: false,
                errors: convertBFFErrors(data.messages),
                data: null,
            };
        }
        return {
            errors: null,
            data: (0, transformCartCheckoutSuccessData_1.transformCartCheckoutSuccessData)(data),
            success: true,
        };
    })
        .catch(function (error) {
        return JSON.parse(error.message);
    });
}
exports.cartCheckoutGraphRequestToCheggResponse = cartCheckoutGraphRequestToCheggResponse;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/index.js
// module id = 211
// module chunks = 11